export const widgetId = '#springbok_chatbot_widget'

export const iconMapping = {
    rightarrow: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/rightarrow.svg',
    socialcare: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/socialcare.svg',
    benefits: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/benefits.svg',
    other: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/other.svg',
    no: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/no.svg',
    uparrow: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/uparrow.svg',
    downarrow: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/downarrow.svg',
    nosocialcare: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/nosocialcare.svg',
    factsheets: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/factsheets.svg',
    letter: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/letter.svg',
    faq: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/faq.svg',
    emailtranscript: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/emailtranscript.svg',
    downloadtemplate: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/downloadtemplate.svg',
    yes: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/yes.svg',
    website: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/website.png',
    easyread: 'https://ascsaasstorageaccountdev.blob.core.windows.net/asc-saas-widget-dev/widgetAssets/Easy_Read_Icon.png',
}

export const defaultUserInitial = 'the person with social care needs'
export const defaultRelationship = 'relative or friend'
export const defaultUserName = 'User'
export const defaultCapitalisedUserInitial = 'The person with social care needs'

// contentful is standard contentful responses
// contentfului are contentful pages with user input responses
// contentfulstore are contentful button click responses where this stores some information for the frontend (i.e relationship)
// contentfulse are contentful pages where button clicks trigger some side effect in the plugin (store something to db usually...)

export const axiosConfig = {
    headers: {
        'Content-Type': 'application/json',
    },
}

export const keywordMapping = {
        'urgency': 'contentful',
        'userexprience': 'contentful',
        'downloadtemplate': 'contentful',
        'video': 'contentful',
        'userinput': 'contentfului',//'userinput',
        'emailinput': 'emailinput',//'emailinput',
        'initial': 'contentfului',//'initial',
        'letterfill': 'letterfill',//'letterfill',
        'rasainput': 'rasa',//'rasainput',
        'postcode': 'postcode',
        'lasave': 'contentfulse',
        'careProvider': 'contentfulstore',//'careProvider',
        'fuzzysearch': 'contentfului',
        'userexperience': 'contentfulse',
        'armedservices': 'contentfulse',
        'equalities-person-type': 'contentfulse',
        'equalities-disability': 'contentfulse',
        'equalities-age-range': 'contentfulse',
        'ethnicity': 'contentfulse',
        'ethnicityinput': 'contentfulse',//'ethnicityinput',
        'userfeedback': 'contentfulse',//'userfeedback',
        'disabilityinput': 'contentfulse',//'disabilityinput',
        'relationship-person-description': 'contentfulstore',
        'relationship-family-member': 'contentfulstore',
        'relationshipdescriptioninput': 'contentfului',//'relationshipdescriptioninput',
        'familymemberinput': 'contentfului',//'familymemberinput',
        'personaone': 'persona',
        'personatwo': 'persona',
        'personathree': 'persona'
}

export const personaTwoIDs = [
    '1l5dgR8DbLQuu9rrbmBEgF', // ENTRY - 2A (backup case)
    'msFnO8u7bUa0upyrgddQt', // HELP - I am a social care provider
    '1Ki7bym854kneJPb3cWBwu', // MAIN - I am asking about someone else
]
// (note persona 2 letters DO NOT HAVE B on the end.)

export const personaOneIDs = [
    '4IRYadcikcABPY4HQE9RRU', // MAIN - I am asking for myself
    '1R0oKaBv0EhJ7NGHo3V9h4', // HELP - I am asking about myself
]
// (note persona 1 letters DO  B on the end.)

export const personaThreeIDs = [
    '5yMMgBPUx2fdPQpWafLsEQ', // ENTRY - relationship flows start here
    '6UVVXaig3URrg3gmWZKD8H', // HELP - i am a family carer
]

export const localAuths = [
    'Cheshire East',
    'Kent',
    'Cheshire West and Chester',
    'North Tyneside',
    'Bromley',
    'Islington',
    'Wandsworth',
    'Hampshire',
    'Norfolk',
    'Bracknell Forest',
    'Middlesbrough',
    'Haringey',
    'Hounslow',
    'Swindon',
    'Brighton and Hove',
    'Stockton-on-Tees',
    'Southampton',
    'Worcestershire',
    'Cambridgeshire',
    'Nottinghamshire',
    'Plymouth',
    'Richmond upon Thames',
    'Redcar and Cleveland',
    'Croydon',
    'Warrington',
    'Blackburn with Darwen',
    'Leicestershire',
    'Buckinghamshire',
    'Hammersmith and Fulham',
    'Nottingham',
    'Telford and Wrekin',
    'Bexley',
    'Tameside',
    'Milton keynes',
    'Bournemouth, Christchurch and Poole',
    'Windsor and Maidenhead',
    'Bury',
    'East Riding of Yorkshire',
    'Ealing',
    'Trafford',
    'South Tyneside',
    'Enfield',
    'Suffolk',
    'Stockport',
    'Tower Hamlets',
    'Oldham',
    'Wokingham',
    'Halton',
    'Hackney',
    'West Berkshire',
    'East Sussex',
    'Hertfordshire',
    'Dudley',
    'Kingston upon Hull, City of',
    'Bristol, City of',
    'Central Bedfordshire',
    'Redbridge',
    'Rochdale',
    'Lincolnshire',
    'North Somerset',
    'Merton',
    'Barnet',
    'Havering',
    'Barking and Dagenham',
    'Luton',
    'Sunderland',
    'Staffordshire',
    'Torbay',
    'Slough',
    'North East Lincolnshire',
    'Somerset',
    'Westminster',
    'West Yorkshire',
    'Coventry',
    'Newcastle upon Tyne',
    'Bedford',
    'Rutland',
    'Essex',
    'Barnsley',
    'Doncaster',
    'Rotherham',
    'Sheffield',
    'West Sussex',
    'Cornwall',
    'North Lincolnshire',
    'St. Helens',
    'Kensington and Chelsea',
    'Sefton',
    'Wirral',
    'Lambeth',
    'Reading',
    'Kingston upon Thames',
    'Sutton',
    'City of London',
    'Peterborough',
    'Isles of Scilly',
    'Harrow',
    'Southend-on-Sea',
    'Lewisham',
    'Brent',
    'Knowsley',
    'Darlington',
    'South Gloucestershire',
    'Dorset',
    'Isle of Wight',
    'Northumberland',
    'Wolverhampton',
    'Warwickshire',
    'Devon',
    'Lancashire',
    'Derby',
    'Camden',
    'Thurrock',
    'Gateshead',
    'Surrey',
    'York',
    'Cumbria',
    'Stoke-on-Trent',
    'Leicester',
    'Shropshire',
    'Blackpool',
    'Wiltshire',
    'Liverpool',
    'Hillingdon',
    'Salford',
    'Medway',
    'Newham',
    'Northamptonshire',
    'Wigan',
    'Greenwich',
    'Bolton',
    'Bath and north East Somerset',
    'Oxfordshire',
    'Portsmouth',
    'North yorkshire',
    'Birmingham',
    'Herefordshire',
    'County Durham',
    'Sandwell',
    'Derbyshire',
    'Manchester',
    'Southwark',
    'Solihull',
    'Waltham Forest',
    'Hartlepool',
    'Walsall',
    'Gloucestershire',
]

export const linkMapping = {
    H8b: 'https://www.accesscharity.org.uk/s/H8b-Problems-relating-to-hospital-discharge.docx', // Persona 1 starts
    SC2b: 'https://www.accesscharity.org.uk/s/SC2b-Request-care-plan-after-assessment.doc',
    GEN1: 'https://www.accesscharity.org.uk/s/Factsheet-SC48-Accessing-information-data-about-a-relative-2022-updated.pdf',
    GEN2: 'https://www.accesscharity.org.uk/s/GEN2-Completing-an-Access-Social-Care-letter-2022-updated.pdf',
    SC45: 'https://www.accesscharity.org.uk/s/SC45-Community-care-myth-buster-2022-updated.pdf',
    SC70: 'https://www.accesscharity.org.uk/s/SC70-Making-a-complaint-2022-updated.pdf',
    SC74: 'https://www.accesscharity.org.uk/s/SC74-Deciding-if-someone-is-ready-and-safe-to-be-discharged-from-hospital-2022-updated.pdf',
    H4: 'https://www.accesscharity.org.uk/s/H4-Moving-between-hospital-and-a-care-home-2022-updated.pdf',
    WB14: 'https://www.accesscharity.org.uk/s/WB14-How-to-start-the-appeal-process-2022-updated.pdf',
    WB3: 'https://www.accesscharity.org.uk/s/WB3-Mandatory-reconsiderations-late-requests-2022-updated.pdf',
    WB9: 'https://www.accesscharity.org.uk/s/WB9-Personal-independencePayment-filling-in-yourPIP2-Form-2022-updated.pdf',
    H9: 'https://www.accesscharity.org.uk/s/H9-Process-local-authorities-must-follow-when-discharging-someone-from-hospital-2022-updated.pdf',
    SC8: 'https://www.accesscharity.org.uk/s/SC8-Moving-accommodation-2022-update.pdf',
    SC54: 'https://www.accesscharity.org.uk/s/SC54-Inter-agency-disputes-LA-2022-updated.pdf',
    SC57: 'https://www.accesscharity.org.uk/s/SC57-Carers-assessments-2022-updated.pdf',
    SC12b: 'https://www.accesscharity.org.uk/s/SC12b-Concerns-about-an-assessor.docx',
    SC13b: 'https://www.accesscharity.org.uk/s/SC13b-Concerns-about-assessment.docx',
    SC14b: 'https://www.accesscharity.org.uk/s/SC14b-Concerns-about-delay.docx',
    SC23b: 'https://www.accesscharity.org.uk/s/SC26b-and-23b-Moving-local-authorities_.docx', // and SC26b combined
    SC25b: 'https://www.accesscharity.org.uk/s/SC25b-Involving-an-advocate.docx',
    SC32b: 'https://www.accesscharity.org.uk/s/SC32b-Request-review-of-financial-charges-non-residential.docx',
    SC33b: 'https://www.accesscharity.org.uk/s/SC33b-Request-direct-payment-increase-after-NMW-uplift.docx',
    SC61b: 'https://accesssocialcare.squarespace.com/s/SC61b-v2-Cut-in-support-assessment-but-no-copy-PL.docx',
    SC62b: 'https://www.accesscharity.org.uk/s/SC62b-Cut-in-support-assessment-but-not-happy-PL.docx',
    SC66b: 'https://www.accesscharity.org.uk/s/SC66b-Direct-payments-support-needed-PL.docx',
    SC71b: 'https://www.accesscharity.org.uk/s/SC71b-Needs-assessment-request-precedent-letter.docx',
    SC79b: 'https://www.accesscharity.org.uk/s/SC79b-PL-Request-copy-of-financial-assessment.docx',
    SC80b: 'https://www.accesscharity.org.uk/s/SC80b-PL-Complaint-letter.docx',
    SC82b: 'https://www.accesscharity.org.uk/s/SC82b-PL-Move-will-not-meet-needs.docx',
    SC83b: 'https://www.accesscharity.org.uk/s/SC83b-PL-Move-stopped-until-assessment.docx',
    SC84b: 'https://www.accesscharity.org.uk/s/SC84b-PL-Safeguarding.docx',
    SC85b: 'https://www.accesscharity.org.uk/s/SC85b-PL-I-want-to-move.docx',
    SC86b: 'https://www.accesscharity.org.uk/s/SC86b-PL-I-want-to-move-and-LA-refused.docx',
    SC87b: 'https://www.accesscharity.org.uk/s/SC87b-PL-Support-not-meeting-needs-request-docs.docx',
    SC88b: 'https://www.accesscharity.org.uk/s/SC88b-PL-Needs-have-changed-request-assessment.docx',
    SC89b: 'https://www.accesscharity.org.uk/s/SC89b-PL-Support-not-meeting-needs-care-review.docx',
    SC90b: 'https://www.accesscharity.org.uk/s/SC90b-PL-Support-not-meeting-needs-annual-review.docx',
    SC91b: 'https://www.accesscharity.org.uk/s/SC91b-PL-Support-not-meeting-needs-bad-assessor.docx',
    SC92b: 'https://www.accesscharity.org.uk/s/SC92b-PL-Support-not-meeting-needs-poor-assessment-supporter.docx',
    SC93b: 'https://www.accesscharity.org.uk/s/SC93b-PL-Support-not-meeting-needs-poor-assessment-needs.docx',
    SC94b: 'https://www.accesscharity.org.uk/s/SC94b-PL-Support-not-meeting-needs-poor-assessment.docx',
    SC95b: 'https://www.accesscharity.org.uk/s/SC95b-Support-not-started.docx',
    SC77b: 'https://www.accesscharity.org.uk/s/SC77b-Unlawful-cut-without-assessment-PL.docx',
    WB15b: 'https://www.accesscharity.org.uk/s/WB15b-mandatory-reconsiderations-for-PIP.docx',
    WB16b: 'https://www.accesscharity.org.uk/s/WB16b-Reasonable-adjustments.docx',
    SC26b: 'https://www.accesscharity.org.uk/s/SC26b-and-23b-Moving-local-authorities_.docx',
    SC96b: 'https://www.accesscharity.org.uk/s/SC96b-urgent-support-and-assessment.docx',
    SC97b: 'https://accesssocialcare.squarespace.com/s/SC97b-Potential-Cut-in-support-assessment-but-no-copy-PL.docx',
    SC63b: 'https://accesssocialcare.squarespace.com/s/SC63b-Cut-in-support-no-assessment-PL-7s3l.docx', // Persona 1 End
    SC90: 'https://accesssocialcare.squarespace.com/s/SC90-PL-Support-not-meeting-needs-ann-review.docx', // Persona 2 Start
    SC12: 'https://www.accesscharity.org.uk/s/SC12-Concerns-about-an-assessor.docx',
    SC13: 'https://www.accesscharity.org.uk/s/SC13-Concerns-about-assessment.docx',
    SC14: 'https://www.accesscharity.org.uk/s/SC14-Concerns-about-delay.docx',
    SC23: 'https://accesssocialcare.squarespace.com/s/SC23SC26-combined-Movinglocalauthorities.docx',
    SC25: 'https://www.accesscharity.org.uk/s/SC25-Involving-an-advocate.docx',
    SC26: 'https://accesssocialcare.squarespace.com/s/SC23SC26-combined-Movinglocalauthorities.docx',
    SC32: 'https://www.accesscharity.org.uk/s/SC32-Request-review-of-financial-charges-non-residential.docx',
    SC33: 'https://www.accesscharity.org.uk/s/SC33-Request-direct-payment-increase-after-National-Minimum-Wage-uplift.docx',
    SC61: 'https://www.accesscharity.org.uk/s/SC61v2-Cut-in-support-assessment-but-no-copy-PL.docx',
    H7: 'https://www.accesscharity.org.uk/s/H7-Challenge-a-DNAR-notice.docx',
    H8: 'https://www.accesscharity.org.uk/s/H8-Problems-relating-to-hospital-discharge.docx',
    MCA3: 'https://www.accesscharity.org.uk/s/MCA3-Failure-to-assess-capacity.docx',
    SC9: 'https://www.accesscharity.org.uk/s/SC9-Request-needs-assessment-for-a-person-lacking-capacity-77tb.doc',
    SC10: 'https://www.accesscharity.org.uk/s/SC10-Request-a-needs-assessment-for-a-child.docx',
    SC24: 'https://www.accesscharity.org.uk/s/SC24-Refused-as-an-appropriate-person.docx',
    SC30: 'https://www.accesscharity.org.uk/s/SC30-Request-carers-assessment-under-section-10-of-the-Care-Act.doc',
    SG1: 'https://www.accesscharity.org.uk/s/SG1-Safeguarding-template-letter-for-family-members.docx',
    SC18: 'https://www.accesscharity.org.uk/s/SC18-Request-increase-in-direct-payments.docx',
    SC15: 'https://www.accesscharity.org.uk/s/SC15-After-assessment-emergency-support.doc',
    SC53: 'https://www.accesscharity.org.uk/s/SC53-After-assessment-request-carers-support-plan.doc',
    SC96: 'https://www.accesscharity.org.uk/s/SC96-urgent-support-and-assessment.docx',
    SC79: 'https://www.accesscharity.org.uk/s/SC79-PL-Request-copy-of-financial-assessment.docx',
    SC84: 'https://www.accesscharity.org.uk/s/SC84-PL-Safeguarding.docx ',
    SC87: 'https://www.accesscharity.org.uk/s/SC87-PL-Support-not-meeting-needs-ask-docs.docx',
    SC88: 'https://www.accesscharity.org.uk/s/SC88-PL-Needs-have-changed-ask-assessment.docx',
    SC91: 'https://www.accesscharity.org.uk/s/SC91-PL-Support-not-meeting-needs-assessor.docx',
    SC92: 'https://www.accesscharity.org.uk/s/SC92-PL-Support-not-meeting-needs-supporter-s7cm.docx',
    SC93: 'https://www.accesscharity.org.uk/s/SC93-PL-Support-not-meeting-needs-assess-cover-ws9l.docx',
    SC66: 'https://www.accesscharity.org.uk/s/SC66-Direct-payments-support-needed-PL.docx',
    SC82: 'https://www.accesscharity.org.uk/s/SC82-PL-Move-will-not-meet-needs.docx',
    SC83: 'https://www.accesscharity.org.uk/s/SC83-PL-Move-stopped-until-assessment.docx',
    SC86: 'https://www.accesscharity.org.uk/s/SC86-PL-I-want-to-move-and-LA-refused.docx',
    SC2: 'https://www.accesscharity.org.uk/s/SC2-Request-care-plan-after-assessment-8ghg.doc',
    SC95: 'https://www.accesscharity.org.uk/s/SC95-PL-Support-not-started.docx',
    SC63: 'https://www.accesscharity.org.uk/s/SC63-Cut-in-support-no-assessment-PL.docx',
    SC89: 'https://www.accesscharity.org.uk/s/SC89-PL-Support-not-meeting-needs-care-review.docx',
    SC80: 'https://www.accesscharity.org.uk/s/SC80-PL-Complaint-letter.docx',
    SC62: 'https://www.accesscharity.org.uk/s/SC62CU1.DOC',
    SC97: 'https://www.accesscharity.org.uk/s/SC97PO1.DOC',
    SC77: 'https://www.accesscharity.org.uk/s/SC77-Unlawful-cut-without-assessment-PL.docx',
    SC60: 'https://www.accesscharity.org.uk/s/SC60-Continuity-of-care-2022-updated.pdf',
    SC85: 'https://www.accesscharity.org.uk/s/SC85-PL-I-want-to-move.docx', // Persona II End
    SC90c: 'https://accesssocialcare.squarespace.com/s/SC90-PL-Support-not-meeting-needs-ann-review.docx', // Persona III starts
    SC12c: 'https://www.accesscharity.org.uk/s/SC12-Concerns-about-an-assessor.docx',
    SC13c: 'https://www.accesscharity.org.uk/s/SC12-Concerns-about-an-assessor.docx',
    SC14c: 'https://www.accesscharity.org.uk/s/SC14-Concerns-about-delay.docx',
    SC23c: 'https://accesssocialcare.squarespace.com/s/SC23SC26-combined-Movinglocalauthorities.docx',
    SC25c: 'https://www.accesscharity.org.uk/s/SC25-Involving-an-advocate.docx',
    SC26c: 'https://accesssocialcare.squarespace.com/s/SC23SC26-combined-Movinglocalauthorities.docx',
    SC32c: 'https://www.accesscharity.org.uk/s/SC32-Request-review-of-financial-charges-non-residential.docx',
    SC33c: 'https://www.accesscharity.org.uk/s/SC33-Request-direct-payment-increase-after-National-Minimum-Wage-uplift.docx',
    SC61c: 'https://www.accesscharity.org.uk/s/SC61v2-Cut-in-support-assessment-but-no-copy-PL.docx',
    H7c: 'https://www.accesscharity.org.uk/s/H7-Challenge-a-DNAR-notice.docx',
    H8c: 'https://www.accesscharity.org.uk/s/H8-Problems-relating-to-hospital-discharge.docx',
    MCA3c: 'https://www.accesscharity.org.uk/s/MCA3-Failure-to-assess-capacity.docx',
    SC9c: 'https://www.accesscharity.org.uk/s/SC9-Request-needs-assessment-for-a-person-lacking-capacity-77tb.doc',
    SC10c: 'https://www.accesscharity.org.uk/s/SC10-Request-a-needs-assessment-for-a-child.docx',
    SC24c: 'https://www.accesscharity.org.uk/s/SC24-Refused-as-an-appropriate-person.docx',
    SC30c: 'https://www.accesscharity.org.uk/s/SC30-Request-carers-assessment-under-section-10-of-the-Care-Act.doc',
    SG1c: 'https://www.accesscharity.org.uk/s/SG1-Safeguarding-template-letter-for-family-members.docx',
    SC18c: 'https://www.accesscharity.org.uk/s/SC18-Request-increase-in-direct-payments.docx',
    SC15c: 'https://www.accesscharity.org.uk/s/SC15-After-assessment-emergency-support.doc',
    SC53c: 'https://www.accesscharity.org.uk/s/SC53-After-assessment-request-carers-support-plan.doc',
    SC96c: 'https://www.accesscharity.org.uk/s/SC96-urgent-support-and-assessment.docx',
    SC79c: 'https://www.accesscharity.org.uk/s/SC79-PL-Request-copy-of-financial-assessment.docx',
    SC84c: 'https://www.accesscharity.org.uk/s/SC84-PL-Safeguarding.docx ',
    SC87c: 'https://www.accesscharity.org.uk/s/SC87-PL-Support-not-meeting-needs-ask-docs.docx',
    SC88c: 'https://www.accesscharity.org.uk/s/SC88-PL-Needs-have-changed-ask-assessment.docx',
    SC91c: 'https://www.accesscharity.org.uk/s/SC91-PL-Support-not-meeting-needs-assessor.docx',
    SC92c: 'https://www.accesscharity.org.uk/s/SC92-PL-Support-not-meeting-needs-supporter-s7cm.docx',
    SC93c: 'https://www.accesscharity.org.uk/s/SC93-PL-Support-not-meeting-needs-assess-cover-ws9l.docx',
    SC66c: 'https://www.accesscharity.org.uk/s/SC66-Direct-payments-support-needed-PL.docx',
    SC82c: 'https://www.accesscharity.org.uk/s/SC82-PL-Move-will-not-meet-needs.docx',
    SC83c: 'https://www.accesscharity.org.uk/s/SC83-PL-Move-stopped-until-assessment.docx',
    SC86c: 'https://www.accesscharity.org.uk/s/SC86-PL-I-want-to-move-and-LA-refused.docx',
    SC71: 'https://www.accesscharity.org.uk/s/SC71-Needs-assessment-request-PL.docx',
    SC2c: 'https://www.accesscharity.org.uk/s/SC2-Request-care-plan-after-assessment-8ghg.doc',
    SC95c: 'https://www.accesscharity.org.uk/s/SC95-PL-Support-not-started.docx',
    SC63c: 'https://www.accesscharity.org.uk/s/SC63-Cut-in-support-no-assessment-PL.docx',
    SC89c: 'https://www.accesscharity.org.uk/s/SC89-PL-Support-not-meeting-needs-care-review.docx',
    SC80c: 'https://www.accesscharity.org.uk/s/SC80-PL-Complaint-letter.docx',
    SC62c: 'https://www.accesscharity.org.uk/s/SC62CU1.DOC',
    SC97c: 'https://www.accesscharity.org.uk/s/SC97PO1.DOC',
    SC77c: 'https://www.accesscharity.org.uk/s/SC77-Unlawful-cut-without-assessment-PL.docx',
    SC85c: 'https://www.accesscharity.org.uk/s/SC85-PL-I-want-to-move.docx', // Persona III End
    H10: 'https://www.accesscharity.org.uk/s/H10-Deciding-if-someone-is-ready-and-safe-to-be-discharged-from-hospital-2022-updated.pdf', // factsheet sections
    MCA2: 'https://www.accesscharity.org.uk/s/MCA2-Assessing-mental-capacity-when-making-decisions-2022-updated.pdf',
    SC3: 'https://www.accesscharity.org.uk/s/SC3-Direct-payments-overview-2022-updated.pdf',
    SC5: 'https://www.accesscharity.org.uk/s/SC5-Financial-charges-for-care2022-updated.pdf',
    SC11: 'https://www.accesscharity.org.uk/s/SC11-Social-Care-Needs-Assessment-Information-Pack-2022-updated.pdf',
    SC67: 'https://www.accesscharity.org.uk/s/SC67-Eligible-needs-2022-updated.pdf',
    SC76: 'https://www.accesscharity.org.uk/s/SC76-Transition-assessments-2022-updated.pdf',
    WB2: 'https://www.accesscharity.org.uk/s/WB2-Mandatory-reconsiderations-2022-updated.pdf',
    WB7: 'https://www.accesscharity.org.uk/s/WB7-Delays-in-receiving-benefits-2022-updated.pdf',
    WB8: 'https://www.accesscharity.org.uk/s/WB8-Reasonable-adjustments-2022-updated.pdf',
    WB10: 'https://www.accesscharity.org.uk/s/WB10Personal-independent-payment-assessment-2022-updated.pdf',
    WB11: 'https://www.accesscharity.org.uk/s/WB11-Work-Capability-Assessment-2022-updated.pdf',
    WB12: 'https://www.accesscharity.org.uk/s/WB12Personal-independence-payment-factsheet-2022-updated.pdf',
    WB13: 'https://www.accesscharity.org.uk/s/WB13-Recovery-of-overpayment-of-benefits-2022-updated.pdf',
    ER24: 'https://www.accesscharity.org.uk/s/ER24-Charging-2022-updated.pdf',
    ER46: 'https://www.accesscharity.org.uk/s/ER46-Needs-assessments-2022-updated.pdf',
    ER146: 'https://www.accesscharity.org.uk/s/ER146-Supported-living-2022-updated.pdf',
    ER47: 'https://www.accesscharity.org.uk/s/ER47-Delay-after-assessment-2022-update.pdf',
    ER96: 'https://www.accesscharity.org.uk/s/ER96-Care-Act-2022-updated.pdf',
    ER70: 'https://www.accesscharity.org.uk/s/ER70-Care-and-support-plans-2022-updated.pdf',
    ER11: 'https://www.accesscharity.org.uk/s/ER11-How-to-get-care-and-support-2022-updated.pdf',
    ER20: 'https://www.accesscharity.org.uk/s/ER20-Court-of-Protection-2022-updated.pdf',
    ER16: 'https://www.accesscharity.org.uk/s/ER16-Appointees-2022-updated.pdf',
    ER21: 'https://www.accesscharity.org.uk/s/ER21-Deprivation-of-Liberty-2022-updated.pdf',
    ER52: 'https://www.accesscharity.org.uk/s/ER52-When-to-ask-for-an-independent-advocate-2022-updated.pdf',
    ER93: 'https://www.accesscharity.org.uk/s/ER93-Advocacy-2022-updated.pdf',
    ER31: 'https://www.accesscharity.org.uk/s/ER31-Refusal-to-Assess-2022-updated.pdf',
    SC41: 'https://www.accesscharity.org.uk/s/SC41-Social-Care-Assessments-What-happens-next-2022-updated.pdf',
    SC42: 'https://www.accesscharity.org.uk/s/SC42-Social-care-assessments-and-duties-children-and-young-people-under-18.pdf',
    SC46: 'https://www.accesscharity.org.uk/s/SC46-How-to-request-an-increase-in-your-direct-payments-2022-updated.pdf',
    SC49: 'https://www.accesscharity.org.uk/s/SC49-Financial-charges-forcare-2022-updated.pdf',
    SC50: 'https://www.accesscharity.org.uk/s/SC50-Advocacy-in-the-assessment-and-care-planning-process-2022-updated.pdf',
    MCA1: 'https://www.accesscharity.org.uk/s/MCA1-Appointees-deputies-and-powers-of-attorney-2022-updated.pdf',
    SC6: 'https://www.accesscharity.org.uk/s/SC6-Reviews-and-assessments-2022-updated.pdf',
    SC37: 'https://www.accesscharity.org.uk/s/SC37-Advocacy-refused-as-appropriate-person-2022.pdf',
    SC55: 'https://www.accesscharity.org.uk/s/SC55-Adult-social-care-assessment-factsheet-2022-updated.pdf',
    ER58: 'https://accesssocialcare.squarespace.com/s/58_advocate_complaint.pdf',
    ER140: 'https://www.accesscharity.org.uk/s/ER140-Self-Advocacy-2022-updated.pdf',
    ER1: 'https://www.accesscharity.org.uk/s/ER1-Community-Care-Assessment-Process-for-Adults-2022-updated.pdf',
    ER141: 'https://www.accesscharity.org.uk/s/ER141-Self-Assessment-2022-updated.pdf',
    ER8: 'https://www.accesscharity.org.uk/s/ER8-Social-Worker-2022-updated.pdf',
    ER19: 'https://www.accesscharity.org.uk/s/ER19-Hiring-Care-Workers-2022-updated.pdf',
    ER101: 'https://www.accesscharity.org.uk/s/ER101-CQC-2022-updated.pdf',
    ER6: 'https://www.accesscharity.org.uk/s/ER6-Support-Ineligible-2022-updated.pdf',
    ER43: 'https://www.accesscharity.org.uk/s/ER43-Ineligible-for-Support-2022-updated.pdf',
    ER15: 'https://www.accesscharity.org.uk/s/ER15-Social-Care-in-my-Area-2022-updated.pdf',
    ER39: 'https://www.accesscharity.org.uk/s/ER39-Short-Breaks-2022-updated.pdf',
    ER74: 'https://www.accesscharity.org.uk/s/ER74-Local-Services-2022-updated.pdf',
    ER122: 'https://www.accesscharity.org.uk/s/ER122-Indicative-Personal-Budget-2022-updated.pdf',
    ER131: 'https://www.accesscharity.org.uk/s/ER131-Nominated-Person-2022-updated.pdf',
    ER133: 'https://www.accesscharity.org.uk/s/ER133-Personalisation-2022-updated.pdf',
    ER136: 'https://www.accesscharity.org.uk/s/ER136-Respite-Care-2022-updated.pdf',
    ER4: 'https://www.accesscharity.org.uk/s/ER4-Parent-Income-Charge-2022-updated.pdf',
    SC68: 'https://www.accesscharity.org.uk/s/SC68-Eligible-needs-not-met-precedent-letter.docx',
    SC40: 'https://www.accesscharity.org.uk/s/SC40-Short-term-care-and-respite-2022-updated.pdf',
    ER75: 'https://www.accesscharity.org.uk/s/ER75-Cuts-to-Care-and-Support-2022-updated.pdf',
    SC64: 'https://www.accesscharity.org.uk/s/SC64-Direct-payments-refused-PL.docx',
    SC65: 'https://www.accesscharity.org.uk/s/SC65-Direct-payments-request-PL.docx',
    ER2: 'https://www.accesscharity.org.uk/s/ER2-Direct-Payments-2022-updated.pdf',
    ER107: 'https://www.accesscharity.org.uk/s/ER107-Clinical-Commissioning-Group-2022-updated.pdf',
    ER7: 'https://www.accesscharity.org.uk/s/ER7-Assessing-Mental-Capacity-2022-updated.pdf',
    ER9: 'https://www.accesscharity.org.uk/s/ER9-Financial-Charges-2022-updated.pdf',
    ER10: 'https://www.accesscharity.org.uk/s/ER10-Mandatory-Reconsiderations-2022-updated.pdf',
    ER3: 'https://www.accesscharity.org.uk/s/ER3-Assessments-when-moving-area-2022-updated.pdf',
    ER5: 'https://www.accesscharity.org.uk/s/ER5-Moving-Area-2022-updated.pdf',
    SC75: 'https://www.accesscharity.org.uk/s/SC75-Safeguarding-PL.docx',
    SC7: 'https://www.accesscharity.org.uk/s/SC7-What-is-Advocacy-2022-updated.pdf', // End of factsheet section
    CHC1c: 'https://www.accesscharity.org.uk/s/CHC1c-Request-for-NHS-CHC-Assessment.docx', // CHC letters start here
    CHC2c: 'https://www.accesscharity.org.uk/s/CHC2c-Request-for-fast-track-assessment.docx',
    CHC3c: 'https://www.accesscharity.org.uk/s/CHC3c-Request-for-review-of-negative-NHS-CHC-checklist.docx',
    CHC4c: 'https://www.accesscharity.org.uk/s/CHC4c-Request-for-review-of-negative-NHS-CHC-eligibility-decision.docx',
    CHC5c: 'https://www.accesscharity.org.uk/s/CHC5c-Request-for-interim-support-pending-NHS-CHC-eligibility-decision.docx',
    CHC6c: 'https://www.accesscharity.org.uk/s/CHC6c-Unilateral-withdrawal-of-NHS-CHC-funding.docx',
    CHC7c: 'https://www.accesscharity.org.uk/s/CHC7c-Complaint-regarding-NHS-CHC-care-plan.docx',
    CHC1: 'https://www.accesscharity.org.uk/s/CHC1-Request-for-NHS-CHC-Assessment.docx',
    CHC2: 'https://www.accesscharity.org.uk/s/CHC2-Request-for-fast-track-assessment.docx',
    CHC3: 'https://www.accesscharity.org.uk/s/CHC3-Request-for-review-of-negative-NHS-CHC-checklist.docx',
    CHC4: 'https://www.accesscharity.org.uk/s/CHC4-Request-for-review-of-negative-NHS-CHC-eligibility-decision.docx',
    CHC5: 'https://www.accesscharity.org.uk/s/CHC5-Request-for-interim-support-pending-NHS-CHC-eligibility-decision.docx',
    CHC6: 'https://www.accesscharity.org.uk/s/CHC6-Unilateral-withdrawal-of-NHS-CHC-funding.docx',
    CHC7: 'https://www.accesscharity.org.uk/s/CHC7-Complaint-regarding-NHS-CHC-care-plan.docx',
    CHC1b: 'https://www.accesscharity.org.uk/s/CHC1b-Request-for-NHS-CHC-Assessment.docx',
    CHC2b: 'https://www.accesscharity.org.uk/s/CHC2b-Request-for-fast-track-assessment.docx',
    CHC3b: 'https://www.accesscharity.org.uk/s/CHC3b-Request-for-review-of-negative-NHS-CHC-checklist.docx',
    CHC4b: 'https://www.accesscharity.org.uk/s/CHC4b-Request-for-review-of-negative-NHS-CHC-eligibility-decision.docx',
    CHC5b: 'https://www.accesscharity.org.uk/s/CHC5b-Request-for-interim-support-pending-NHS-CHC-eligibility-decision.docx',
    CHC6b: 'https://www.accesscharity.org.uk/s/CHC6b-Unilateral-withdrawal-of-NHS-CHC-funding.docx',
    CHC7b: 'https://www.accesscharity.org.uk/s/CHC7b-Complaint-regarding-NHS-CHC-care-plan-8zef.docx',
};
  
